import { render, staticRenderFns } from "./BeneficiaryBadgeWizard.vue?vue&type=template&id=4501b4e2&"
import script from "./BeneficiaryBadgeWizard.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBadgeWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports